export function setSumLabels(datasets, ctx) {
  let sum = 0;
  datasets.map((dataset) => {
    sum += dataset.data[ctx.dataIndex];
  });

  return sum;
}

export function setDatasets(ctx) {
  return ctx.chart.data.datasets.filter((ds) => {
    if (ds._meta[0]) {
      return !ds._meta[0].hidden;
    }
    return true;
  });
}
